export class Folder {
  public id: number;
  public name: string;
}
